/* eslint-disable react/prop-types */
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const maxPageNumbers = 5; // Maximum page numbers to show before truncation

    const generatePageNumbers = () => {
        const pages = [];
        const halfWay = Math.floor(maxPageNumbers / 2);

        if (totalPages <= maxPageNumbers) {
            for (let i = 1; i <= totalPages; i++) pages.push(i);
        } else if (currentPage <= halfWay + 1) {
            for (let i = 1; i <= maxPageNumbers - 2; i++) pages.push(i);
            pages.push("...");
            pages.push(totalPages);
        } else if (currentPage >= totalPages - halfWay) {
            pages.push(1);
            pages.push("...");
            for (let i = totalPages - (maxPageNumbers - 2); i <= totalPages; i++) pages.push(i);
        } else {
            pages.push(1);
            pages.push("...");
            for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
            pages.push("...");
            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <div className="flex items-center gap-2 bg-color2 text-white px-4 py-2 rounded-md">
            {/* Previous Button */}
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="px-3 py-3 bg-color3 rounded disabled:opacity-50"
            >
                <FaAngleLeft />
            </button>

            {/* Page Numbers */}
            {generatePageNumbers().map((page, index) =>
                page === "..." ? (
                    <span key={index} className="px-3 py-2">...</span>
                ) : (
                    <button
                        key={index}
                        onClick={() => onPageChange(page)}
                        className={`px-4 py-2 rounded ${
                            currentPage === page ? "bg-color6 text-black" : " bg-color3"
                        }`}
                    >
                        {page}
                    </button>
                )
            )}

            {/* Next Button */}
            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="px-3 py-3 bg-color3 rounded disabled:opacity-50"
            >
                <FaAngleRight />
            </button>
        </div>
    );
};

export default Pagination;
